import React, { useEffect, useState } from 'react'
import { CustomPanel, MenuItem, PageHeader } from '../../../../components'
import { withRouter } from 'react-router-dom'
import usePickingMaisOpcoes from './PickingMaisOpcoesState'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import AcompanhamentoItensSeparadosModal from './AcompanhamentoItensSeparados/AcompanhamentoItensSeparados'

function PickingMaisOpcoes({ history, dispatch }) {
  const picking = history.location.state.selectedPicking
  const [showAcompanhamento, setShowAcompanhamento] = useState(false)

  // Hooks
  const { state, localDispatch } = usePickingMaisOpcoes()
  useEffect(() => {
    if (state.loadingMessage === 'Exportando as informações do Picking') {
      dispatch(showLoadingBox(state.loadingMessage, 'Exportando . . .'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Constants
  const menuItems = [
    { menu: '8. Exportar Dados do Picking', cmd: () => localDispatch.exportarPicking(picking) },
    {
      menu: '9. Histórico de Leitura',
      cmd: () => history.push('/main/picking/historico-leitura', { pickingId: picking.id }),
    },
    {
      menu: '10. Formulário Reconferência Faltas e Sobras',
      cmd: () => localDispatch.openFormularioReconferencia(picking),
    },
    {
      menu: '11. Resumo Separação Analítico',
      cmd: () => localDispatch.openResumoSeparacaoAnalitico(picking),
    },
    {
      menu: '12. Resumo Separação Por Origem',
      cmd: () => localDispatch.openResumoSeparacaoPorOrigemPDF(picking),
    },
    {
      menu: '13. Comparativo do Picking',
      cmd: () => history.push('/main/picking/comparativo-picking', { picking }),
    },
    {
      menu: '14. Listagem de Produtos Conferidos/Separados',
      cmd: () => localDispatch.openListagemDeProdutosConferidosPDF(picking),
    },
    {
      menu: '15. Relação das Posições de Estoque por Pallet Área',
      cmd: () => localDispatch.openRelacaoPosicoesEstoquePalletArea(picking),
    },
    {
      menu: '16. Ficha de Recebimento de Cargas',
      cmd: () => localDispatch.openFichaRecebimentoCarga(picking),
    },
    {
      menu: '17. Comparativo Picking - Lote e Validade',
      cmd: () => localDispatch.openComparativoPickingLoteValidade(picking),
    },
    {
      menu: '18. Acompanhamento Itens Separados',
      cmd: () => setShowAcompanhamento(true),
    },
  ]

  // Render
  return (
    <>
      <PageHeader>
        Mais Opções - Picking: <b>{picking.name}</b>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            {menuItems.map((item, index) => (
              <div key={index} className="p-col-12">
                <MenuItem item={item} />
              </div>
            ))}
          </div>
        </CustomPanel>
      </div>

      <AcompanhamentoItensSeparadosModal
        visible={showAcompanhamento}
        onClose={() => setShowAcompanhamento(false)}
        pickingId={picking.id}
      />
    </>
  )
}

export default connect()(withRouter(PickingMaisOpcoes))
